import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { BsCircle } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import { useReserve } from "../../View/Reserves/Hooks";
import { Color } from "../../../Utils/styles";

function Index({ imageStyle, arr = [], link }) {
  const { pathname } = useLocation();
  const { navigate, renderCategory } = useReserve();

  const SampleNextArrow = () => {
    return <div style={{ display: "none" }} />;
  };

  const SamplePrevArrow = () => {
    return <div style={{ display: "none" }} />;
  };
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    customPaging: function (i) {
      return <></>;
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  if (pathname != "/") {
    arr = [renderCategory().img];
  }
  const renderLink = d => {
    switch (d) {
      case "/img/slider/twoslider/1g.jpg":
        return "Items/سالن-شهید-اکبری-2";
      case "/img/slider/twoslider/2g.jpg":
        return "Items/استخر-مجموعه-کوثر";
      case "/img/slider/twoslider/3g.jpg":
      case "/img/slider/twoslider/zard-2.jpg":
        return "Items/باشگاه-بدنسازی-سکو";
      case "/img/slider/twoslider/zard-1.jpg":
        return "Items/استخر-موج-شاهرود";
      case "/img/slider/twoslider/zard-3.jpg":
        return "Items/سالن-شهید-اکبری-2";

      default:
        break;
    }
  };
  const renderSlider = id => {
    switch (id) {
      case 1:
      case 3:
        return (
          <h1>
            جامع ترین سایت معرفی، اطلاع رسانی و رزرو آنلاین
            <span>{` `}</span>
            <span style={{ color: Color.yellow }}>سالن های ورزشی</span>
          </h1>
        );
      case 2:
        return (
          <h1>
            جامع ترین سایت معرفی، اطلاع رسانی و رزرو آنلاین
            <span>{` `}</span>
            <span style={{ color: Color.primary }}>باشگاه های بدنسازی</span>
          </h1>
        );
      case 4:
        return (
          <h1>
            جامع ترین سایت معرفی، اطلاع رسانی و رزرو آنلاین
            <span>{` `}</span>
            <span style={{ color: Color.blueSlider }}>
              استخر و پارک های آبی
            </span>
          </h1>
        );

      case 5:
        return "dawd";
        break;
      default:
        break;
    }
  };

  const slidersImgs = ["/img/slider/1.jpg", "/img/slider/2.jpg", "/img/slider/3.webp", "/img/slider/4.webp"];

  return (
    <div className="silders">
      <Slider {...settings}>
        {arr.length > 0
          ? arr.map(d => {
            return (
              <div
                className="d-flex justify-content-end"
                key={d}
                style={{
                  position: "relative",
                }}
              >
                {d.component && d.component(d)}
                <img
                  src={d.url || d}
                  alt={
                    d.item && d.item.name
                      ? d.item.name
                      : "رزرو استخر، رزرو باشگاه بدنسازی، رزرو سالن ورزشی"
                  }
                  style={{ ...imageStyle }}
                />
              </div>
            );
          })
          : Array(4)
            .fill(1)
            .map((i, c) => i + c)
            .map(d => {
              return (
                <div
                  className="d-flex justify-content-center "
                  style={{ position: "relative" }}
                  key={d}
                >
                  <div className="hero-slider">{renderSlider(d)}</div>
                  <img
                    src={window.origin + `${slidersImgs[d - 1]}`}
                    alt="رزرو استخر، رزرو باشگاه بدنسازی، رزرو سالن ورزشی"
                    style={{ ...imageStyle }}
                  />
                </div>
              );
            })}
      </Slider>
    </div>
  );
}

export default Index;
